import { ImportDef } from './build';

const NG_FORM_MODULE: ImportDef[] = [{from: '@angular/forms', name: 'FormsModule', as: 'ngFormsModule'}];


export const WIDGET_IMPORTS: Map<string, ImportDef[]> = new Map([
]);
